import { useEffect } from 'react';
import { useSubscription, useMutation } from '@apollo/client';
import { PING } from '../graphql/mutations';
import { USER_ONLINE_STATUS_SUBSCRIPTION } from '../graphql/subscriptions';
import { useAuth } from './AuthContext';

const OnlineStatusManager = () => {
  const { user, updateOnlineStatus } = useAuth();
  const userId = user?.id;
  const [ping] = useMutation(PING, { fetchPolicy: 'no-cache' });

  useSubscription(USER_ONLINE_STATUS_SUBSCRIPTION, {
    skip: !userId,
    variables: { userId },
    shouldResubscribe: false,    // ← вот здесь
    onSubscriptionData({ subscriptionData }) {
      const payload = subscriptionData.data?.userOnlineStatusChanged;
      if (payload) {
        updateOnlineStatus(payload.userId, payload.isOnline);
      }
    },
    onError(err) {
      console.error('❌ Subscription error:', err);
    },
  });

  useEffect(() => {
    if (!userId) return;
    const intervalId = setInterval(() => ping().catch(console.error), 1_000);
    return () => clearInterval(intervalId);
  }, [userId, ping]);

  return null;
};

export default OnlineStatusManager;